import { QueryKey } from 'react-query';
import { TaskCenterQueries, TaskCenterConstants } from '../';
import { IO } from '../types';

interface GetTaskByIdQueryData {
  queryKey: QueryKey;
  requestParams: IO.GetTaskListV2['input'];
}

/**
 * Generates the `request` as well as the `query key` to be used for fetching a task by it's ID.
 */
export const getTaskByIdQueryData = (locationId: string[], taskId?: string | null): GetTaskByIdQueryData => {
  const req = {
    filters: {
      locationId,
      taskId: taskId ? [taskId] : undefined,
    },
    pagination: { limit: TaskCenterConstants.DEFAULT_TASK_LIMIT },
    includeMetadata: true,
  };

  return { queryKey: TaskCenterQueries.queryRequestKeys.taskById(req), requestParams: req };
};
